import 'css-chunk:src/cms/tabGroup/tabGroup.module.scss';export default {
  "tabGroupContainer": "tabGroup-module__tabGroupContainer___My66R",
  "tabsContainer": "tabGroup-module__tabsContainer___6GVm1",
  "tabPanelsContainer": "tabGroup-module__tabPanelsContainer___FsyEn",
  "tabsAccordion": "tabGroup-module__tabsAccordion___f-1fF",
  "tabGroupModelTabContainer": "tabGroup-module__tabGroupModelTabContainer___gNWNF",
  "tabGroupModelTabImageContainer": "tabGroup-module__tabGroupModelTabImageContainer___Ou03r",
  "tabGroupModelTabContentContainer": "tabGroup-module__tabGroupModelTabContentContainer___GJzYD",
  "tabGroupAccordionItemContainer": "tabGroup-module__tabGroupAccordionItemContainer___TMcGB",
  "tabGroupAccordionItemContentContainer": "tabGroup-module__tabGroupAccordionItemContentContainer___hkirF",
  "tabGroupAccordionItemImage": "tabGroup-module__tabGroupAccordionItemImage___qfdOS"
};